import type {Nullable} from '#lit/types/general.js';
import {isHTMLElement} from '#lit/utils/dom.js';
import type FlyListItem from './index.js';
import {COMPONENT_TAG} from './index.js';

export function isFlyListItemElement(
  node?: Nullable<Node | EventTarget>
): node is FlyListItem {
  if (!node || !isHTMLElement(node)) return false;
  return node.nodeName === COMPONENT_TAG.toUpperCase();
}
